module.exports = __webpack_public_path__ + "img/0031.b45dda74.jpg";